<script setup>
const props = defineProps({
  values: { type: Array, default: () => [] },
  modelValue: { type: String, default: '' },
});

const emit = defineEmits(['update:modelValue']);

function optKey(opt) {
  return typeof opt === 'object' ? opt.key : opt;
}
function optLabel(opt) {
  return typeof opt === 'object' ? opt.label : opt;
}

function select(opt) {
  const key = optKey(opt);
  emit('update:modelValue', props.modelValue === key ? '' : key);
}
</script>

<template>
  <div class="flex flex-col gap-1.5">
    <label
      v-for="opt in values"
      :key="optKey(opt)"
      class="flex items-center gap-2 text-sm text-n-slate-12 cursor-pointer"
    >
      <input
        type="radio"
        :checked="modelValue === optKey(opt)"
        :value="optKey(opt)"
        class="w-3.5 h-3.5 accent-n-brand cursor-pointer"
        @change="select(opt)"
      />
      {{ optLabel(opt) }}
    </label>
  </div>
</template>
